import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import {hit} from '../../metrics';
import CaseFooter from '../CaseFooter';
import HelmetSite from '../HelmetSite';
import './style.css';

class Armani extends Component {
  handleVideoPlay = () => {
    const video = document.querySelector('#armani .video video');
    const section = document.querySelector('#armani .section9');
    if (!video || !section) return;

    if (video.paused) {
      video.play();
      section.classList.add('is-playing');
    } else {
      video.pause();
      section.classList.remove('is-playing');
    }
  };

  handleVideoPause = () => {
    const video = document.querySelector('#armani .video video');
    const section = document.querySelector('#armani .section9');
    if (!video || !section) return;
    video.pause();
    section.classList.remove('is-playing');
  };

  handleVideoEnded = () => {
    const section = document.querySelector('#armani .section9');
    if (section) section.classList.remove('is-playing');
  };

  componentDidMount() {
    if(this.props.pathname == '/projects/armani/'){
      this.setState({preview: false});
      this.props.setProjectName('armani');
      $('body').addClass('case-expanded hash-armani');
      $(window).scrollTop($('#armani').offset().top);
      this.props.changeCase(null);
    }
    else{
      this.setState({preview: true});
      $('body').removeClass('hash-armani');
    }
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    setTimeout(() => {
      $('body').addClass('fadepage');
    }, 100);
  }

  componentDidUpdate() {
    if(this.props.pathname == '/projects/'){
      $('body').removeClass('case-expanded hash-armani');
    }
  }
  
  componentWillUnmount() {
    $('body').removeClass('fadepage');
  }
  
  render(){
    return(
      <div className="case">
        <div className="case-content" id="armani">
          <section className="section1">
            <img src="/cases/img/armani/new/img1.webp" />
          </section>

          <section className="section2">
            <div className="main">
              <h1 className="title">Клубные резиденции “Armani / Casa”</h1>
              <dl className="details">
                <div className="detail">
                  <dt>Клиент</dt>
                  <dd>Voshod</dd>
                </div>
                <div className="detail">
                  <dt>Виды работ</dt>
                  <dd>Сайт</dd>
                </div>
              </dl>
            </div>
            <div className="description">
              <p>Сайт отражает суть подхода маэстро Джорджио Армани: вневременная элегантность и&nbsp;внимательность к&nbsp;каждой детали проекта.</p>
            </div>
          </section>

          <section className="section3">
            <div>
              <img src="/cases/img/armani/new/img2.webp" />
            </div>
          </section>

          <section className="section4">
            <div>
              <img src="/cases/img/armani/new/img3.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img4.webp" />
            </div>
          </section>

          <section className="section5">
            <div>
              <img src="/cases/img/armani/new/img5.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img6.webp" />
            </div>
          </section>

          <section className="section6">
            <img src="/cases/img/armani/new/img7.webp" />
          </section>

          <section className="section7">
            <div>
              <img src="/cases/img/armani/new/img8.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img9.webp" />
            </div>
          </section>

          <section className="section8">
            <div>
              <img src="/cases/img/armani/new/img10.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img11.webp" />
            </div>
          </section>

          <section className="section9">
            <div className="video">
              <video src="/cases/img/armani/video.mp4" poster="/cases/img/armani/new/poster.webp" playsInline preload="metadata" onClick={this.handleVideoPause} onEnded={this.handleVideoEnded} />
            </div>
            <button className="play" type="button" aria-label="Play video" onClick={this.handleVideoPlay}>
              <img src="/cases/img/armani/new/play.svg" alt="" />
            </button>
          </section>

          <section className="section10">
            <div>
              <div>
                <img src="/cases/img/armani/new/img12.webp" />
              </div>
            </div>
            <div>
              <div>
                <p>Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко&nbsp;всем необходимым функциям в&nbsp;любое время и&nbsp;в&nbsp;любом месте.</p>
                <p>Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и&nbsp;интуитивной. При&nbsp;этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и&nbsp;создавая гармоничное восприятие даже на&nbsp;небольших экранах.</p>
              </div>
            </div>
          </section>

          <section className="section11">
            <div>
              <img src="/cases/img/armani/new/img13.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img14.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img15.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img16.webp" />
            </div>
          </section>
        </div>

        <CaseFooter 
          to={this.props.next ? this.props.next.url : "/projects/afimall/"}
          title={this.props.next ? this.props.next.name : "Афимолл Сити + Маша и Медведь"} 
          img={this.props.next ? this.props.next.imgCaseBottom : "/cases/img/next/afimall.webp"}
        />

        <HelmetSite title="Armani / Casa Эксклюзивные резиденции" />
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Armani)